import React from "react";
import { AiFillStar } from "react-icons/ai";
import MarginBottom from "./MarginBottom";
const WinningCriteria = () => {
  return (
    <>
      <div className="flex flex-col lg:flex-row justify-between px-[5em] mt-10">
        <div>
          <h2 className="text-lyellow text-3xl sm:text-4xl font-semibold">
            Winning Criteria
          </h2>
          <p className="text-lyellow font-semibold mt-5 text-sm sm:text-xl mr-2">
            The digits and star on your ticket must match the winning order and
            the exact combinaiton does not matter.
          </p>

          <p className="text-white text-sm sm:text-md mt-5">
            Here’s an example lottery draw, with two tickets, A, B, and C.
          </p>
          <ul className="mt-5 text-white text-sm sm:text-md list-disc">
            <li>
              Ticket A: The 5 digits and the 2 stars match even though the order
              is completely different from the winning draw.
            </li>
            <li>
              Ticket B: In the whole sequence, only 2 numbers match even though
              their order is different.
            </li>
            <li>
              Ticket C: Even though 4 digits match and 2 stars match, the
              distribution will be of 4 numbers as this does not fall on the
              criteria.
            </li>
          </ul>
          <p className="text-white mt-5 text-sm sm:text-md mr-10">
            Prize brackets don't "stack": if you match the 4 Numbers category, you'll
            only win prizes from the "4 Numbers" bracket, and not from "3
            Numbers" and "2 Numbers".
          </p>
        </div>

        <div className="block relative right-[3.3rem] p-6 sm:right-0 mt-5 sm:mt-0 w-[22em] sm:w-[25em] bg-black/40 border border-black/80 shadow-md cursor-pointer rounded-2xl">
          <div className="flex flex-col justify-center space-y-5">
            <div className="flex flex-col  items-center">
              <p className="text-lyellow  font-semibold mb-2">Winning Draw</p>
              <div className="flex flex-grow text-xl text-lyellow">
                <p className="mx-5 shadow-md shadow-zinc-400 rounded-full px-2">
                  1
                </p>
                <p className="mr-5 shadow-md shadow-red-400 rounded-full px-2">
                  2
                </p>
                <p className="mr-5 shadow-md shadow-blue-400 rounded-full px-2">
                  3
                </p>
                <p className="mr-5 shadow-md shadow-green-400 rounded-full px-2">
                  4
                </p>
                <p className="mr-5 shadow-md shadow-orange-400 rounded-full px-2">
                  5
                </p>
                <div className="flex">
                  <AiFillStar className="text-[#FFD700] text-sm" />
                  <p className="mr-5 shadow-md shadow-yellow-500 rounded-full px-2">
                    3
                  </p>
                </div>
                <div className="flex">
                  <AiFillStar className="text-[#FFD700] text-sm" />
                  <p className="mr-5 shadow-md shadow-yellow-500 rounded-full px-2">
                    5
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col  items-center pt-2">
              <p className="text-lyellow  font-semibold mb-2">Ticket A</p>
              <div className="flex flex-grow text-xl text-lyellow">
                <p className="mx-5 shadow-md shadow-orange-400 rounded-full px-2">
                  5
                </p>
                <p className="mr-5 shadow-md shadow-blue-400 rounded-full px-2">
                  3
                </p>
                <p className="mr-5 shadow-md shadow-zinc-400 rounded-full px-2">
                  1
                </p>
                <p className="mr-5 shadow-md shadow-red-400 rounded-full px-2">
                  2
                </p>
                <p className="mr-5 shadow-md shadow-green-400 rounded-full px-2">
                  4
                </p>
                <div className="flex">
                  <AiFillStar className="text-[#FFD700] text-sm" />
                  <p className="mr-5 shadow-md shadow-yellow-500 rounded-full px-2">
                    5
                  </p>
                </div>
                <div className="flex">
                  <AiFillStar className="text-[#FFD700] text-sm" />
                  <p className="mr-5 shadow-md shadow-yellow-500 rounded-full px-2">
                    3
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col  items-center pt-2">
              <p className="text-lyellow  font-semibold mb-2">Ticket B</p>
              <div className="flex flex-grow text-xl text-lyellow">
                <p className="mx-5 shadow-md shadow-slate-400 rounded-full px-2">
                  7
                </p>
                <p className="mr-5 shadow-md shadow-blue-400 rounded-full px-2">
                  3
                </p>
                <p className="mr-5 shadow-md shadow-blue-400 rounded-full px-2">
                  9
                </p>
                <p className="mr-5 shadow-md shadow-zinc-400 rounded-full px-2">
                  1
                </p>
                <p className="mr-5 shadow-md shadow-cyan-400 rounded-full px-2">
                  8
                </p>
                <div className="flex">
                  <AiFillStar className="text-[#FFD700] text-sm" />
                  <p className="mr-5 shadow-md shadow-yellow-500 rounded-full px-2">
                    1
                  </p>
                </div>
                <div className="flex">
                  <AiFillStar className="text-[#FFD700] text-sm" />
                  <p className="mr-5 shadow-md shadow-yellow-500 rounded-full px-2">
                    2
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col  items-center pt-2">
              <p className="text-lyellow  font-semibold mb-2">Ticket C</p>
              <div className="flex flex-grow text-xl text-lyellow">
                <p className="mx-5 shadow-md shadow-zinc-400 rounded-full px-2">
                  1
                </p>
                <p className="mr-5 shadow-md shadow-red-400 rounded-full px-2">
                  2
                </p>
                <p className="mr-5 shadow-md shadow-blue-400 rounded-full px-2">
                  3
                </p>
                <p className="mr-5 shadow-md shadow-green-400 rounded-full px-2">
                  4
                </p>
                <p className="mr-5 shadow-md shadow-amber-700 rounded-full px-2">
                  7
                </p>
                <div className="flex">
                  <AiFillStar className="text-[#FFD700] text-sm" />
                  <p className="mr-5 shadow-md shadow-yellow-500 rounded-full px-2">
                    3
                  </p>
                </div>
                <div className="flex">
                  <AiFillStar className="text-[#FFD700] text-sm" />
                  <p className="mr-5 shadow-md shadow-yellow-500 rounded-full px-2">
                    5
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MarginBottom />
    </>
  );
};

export default WinningCriteria;
